import { shallowEqual } from "react-redux";
import type {
    AvailableGradesForConfigurableGradeType,
    AvailableGradesForConfigurableType,
} from "../../../shared-logic/types/AvailableInOtherGradesType";
import type { CarConfigDispatchType } from "../redux/store";
import { useCarConfigSelector } from "../redux/store";
import { availableGradesForConfigurableSelector } from "../utils/selectorUtils";
import {
    CarConfigStep,
    getCarConfigUrl,
} from "../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { selectGradeForConfigurable } from "../redux/slices/CarConfigAvailableInOtherGradesSlice";
import { useDispatch } from "../../../../shared-logic/redux/store";

const useAphAvailableInOtherGrades = (): {
    fetching: boolean;
    availableGradesForConfigurable: AvailableGradesForConfigurableType | undefined;
    selectedGrade: AvailableGradesForConfigurableGradeType | undefined;
    setSelectedGrade: (grade: AvailableGradesForConfigurableGradeType) => void;
    isActive: (availableGradeForConfigurableId: string) => boolean;
    url: string | undefined;
} => {
    const dispatch = useDispatch<CarConfigDispatchType>();

    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const modelId = useCarConfigSelector((state) => state.car.model.id);
    const modelCode = useCarConfigSelector((state) => state.car.model.internalCode);
    const { fetching, availableGradesForConfigurable, selectedGrade } = useCarConfigSelector(
        availableGradesForConfigurableSelector,
        shallowEqual,
    );

    const setSelectedGrade = (grade: AvailableGradesForConfigurableGradeType): void => {
        if (availableGradesForConfigurable) {
            dispatch(
                selectGradeForConfigurable({
                    availableGradesForConfigurable: { ...availableGradesForConfigurable, selectedGradeId: grade.id },
                }),
            );
        }
    };

    const isActive = (availableGradeForConfigurableId: string): boolean =>
        selectedGrade ? selectedGrade.id === availableGradeForConfigurableId : false;

    let url;
    if (selectedGrade && commonSettings) {
        url = getCarConfigUrl(
            commonSettings,
            modelId,
            modelCode,
            selectedGrade.car.id,
            CarConfigStep.Configure,
            {
                colourId: selectedGrade.exteriorColour.id,
                colourCode: selectedGrade.exteriorColour.internalCode,
            },
            {
                upholsteryId: selectedGrade.upholstery.id,
                upholsteryCode: selectedGrade.upholstery.internalCode,
            },
            !selectedGrade.wheel.standard ? selectedGrade.wheel.id : undefined,
        );
    }

    return { fetching, availableGradesForConfigurable, selectedGrade, setSelectedGrade, isActive, url };
};

export default useAphAvailableInOtherGrades;
